export const DISTANCES =
	[
		{ value: 5, text: "5 miles" },
		{ value: 15, text: "15 miles" },
		{ value: 25, text: "25 miles" },
		{ value: 50, text: "50 miles" }
	]